import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import Row from "../../common/Row";
import DatumNVTOptioneel from "../../common/DatumNVTOptioneel";
import AutoBindComponent from "../../common/AutoBindComponent";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import CopyMijlpalenButton from "./CopyMijlpalenButton";
import ConfirmModal from "../../common/ConfirmModal";
import moment from "moment";

class WerkenOpgeleverd extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);
		this.state = {
			selectedInfrastructuur: null,
			confirmModalIsOpen: false
		};
	}
	// let selectedInfrastructuur = moreThenOneOtherInfrastructuur ? null : otherInfrastructuren[0];

	componentWillReceiveProps(nextProps) {
		this.setState({ selectedInfrastructuur: this.props.otherInfrastructuren.length > 1 ? null : this.props.otherInfrastructuren[0] });
	}

	handleOnClickCopyMijlpalen(event) {
		if (event.target.name === "infrastructuurToCopyId")
			return;

		const infrastructuur = this.state.selectedInfrastructuur;
		const infrastructuurIdToCopy = infrastructuur ? infrastructuur["id"] : null;

		if (infrastructuurIdToCopy) {
			this.setState({ confirmModalIsOpen: true });
		}
	}

	handleOnConfirmCopy() {
		const infrastructuur = this.state.selectedInfrastructuur;
		const infrastructuurIdToCopy = infrastructuur ? infrastructuur["id"] : null;

		if (infrastructuurIdToCopy) {
			this.props.onCopyMijlpalen(infrastructuurIdToCopy);
		}
		this.setState({ confirmModalIsOpen: false });
	}

	handleOnCancelCopy() {
		this.setState({ confirmModalIsOpen: false });
	}

	handleOnChangeSelectedInfrastructuur(event) {
		this.setState({ selectedInfrastructuur: this.props.otherInfrastructuren.find(x => x.id == event.target.value) });
	}

	render() {
		const {
			minimaleEisen,
			disabled,
			errors,
			onChange,
			onChangeDateNVT,
			otherInfrastructuren,
			validationMessageType
		} = this.props;

		const hasOtherInfrastructuren = otherInfrastructuren.length > 0;
		const moreThenOneOtherInfrastructuur = otherInfrastructuren.length > 1;

		const nvt = [{ value: "false", label: "Niet van toepassing" }];
		const sharedProps = {
			disabled,
			onChange,
			checkLabel: "",
			onCheckboxChange: onChangeDateNVT,
			textLabel: "Opmerking",
			checkOptions: nvt,
			textOptional: true
		};

		const OPSTARTOVERHEIDSOPDRACHT_TOOLTIP = "Hiermee wordt bedoeld: de opening van de offertes.";
		const EINDEOVERHEIDSOVERDRACHT_TOOLTIP = "Hiermee wordt bedoeld: de toewijzing van de overheidsopdracht.";

		let copyFromOtherInfrastructuurButton = null;
		let buttonNode = null;
		if (hasOtherInfrastructuren) {
			buttonNode = (<CopyMijlpalenButton
				selectedInfrastructuur={this.state.selectedInfrastructuur}
				moreThenOneOtherInfrastructuur={moreThenOneOtherInfrastructuur}
				otherInfrastructuren={otherInfrastructuren}
				disabled={disabled}
				onClickCopyMijlpalen={this.handleOnClickCopyMijlpalen}
				onChangeSelectedInfrastructuur={this.handleOnChangeSelectedInfrastructuur}
				alignRight />);
		}

		return (
			<Fieldset
				title={"Zullen de werken voorlopig opgeleverd zijn op " + moment(minimaleEisen.voorlopigeOpleveringVoor).format("DD-MM-YYYY")}>
				<ConfirmModal
					hookToTop={false}
					isOpen={this.state.confirmModalIsOpen}
					title="Let op!"
					mainText="Controleer zorgvuldig of de gekopieerde informatie wel degelijk van toepassing is op deze infrastructuur."
					confirmAction={this.handleOnConfirmCopy}
					cancelAction={this.handleOnCancelCopy}
					confirmText="Kopieer"
					cancelText="Annuleer" />
				<Row>
					<FieldsetSubHeader>Vul de volgende mijlpalen in</FieldsetSubHeader>
					{buttonNode}
				</Row>
				<br />
				<DatumNVTOptioneel
					{...sharedProps}
					dateLabel="Inschatting van datum goedkeuring RUP"
					dateName="inschattingDatumRUP"
					dateValue={minimaleEisen.inschattingDatumRUP}
					dateError={errors ? errors.inschattingDatumRUP : ''}
					checkName="vanToepassingInschattingDatumRUP"
					checkValue={minimaleEisen.vanToepassingInschattingDatumRUP}
					checkError={errors ? errors.vanToepassingInschattingDatumRUP : ''}
					textName="opmerkingenInschatttingDatumRUP"
					textValue={minimaleEisen.opmerkingenInschatttingDatumRUP}
					textError={errors ? errors.opmerkingenInschatttingDatumRUP : ''}
					textMaxLength={2000}
					validationMessageType={validationMessageType} />
				<DatumNVTOptioneel
					{...sharedProps}
					dateLabel="Opstart overheidsopdracht"
					dateName="opstartOverheidsopdracht"
					dateValue={minimaleEisen.opstartOverheidsopdracht}
					dateError={errors ? errors.opstartOverheidsopdracht : ''}
					dateTooltip={OPSTARTOVERHEIDSOPDRACHT_TOOLTIP}
					checkName="vanToepassingOpstartOverheidsopdracht"
					checkValue={minimaleEisen.vanToepassingOpstartOverheidsopdracht}
					checkError={errors ? errors.vanToepassingOpstartOverheidsopdracht : ''}
					textName="opmerkingenOpstartOverheidsopdracht"
					textValue={minimaleEisen.opmerkingenOpstartOverheidsopdracht}
					textError={errors ? errors.opmerkingenOpstartOverheidsopdracht : ''}
					textMaxLength={2000}
					validationMessageType={validationMessageType} />
				<DatumNVTOptioneel
					{...sharedProps}
					dateLabel="Einde overheidsopdracht"
					dateName="eindeOverheidsopdracht"
					dateValue={minimaleEisen.eindeOverheidsopdracht}
					dateError={errors ? errors.eindeOverheidsopdracht : ''}
					dateTooltip={EINDEOVERHEIDSOVERDRACHT_TOOLTIP}
					checkName="vanToepassingEindeOverheidsopdracht"
					checkValue={minimaleEisen.vanToepassingEindeOverheidsopdracht}
					checkError={errors ? errors.vanToepassingEindeOverheidsopdracht : ''}
					textName="opmerkingenEindeOverheidsopdracht"
					textValue={minimaleEisen.opmerkingenEindeOverheidsopdracht}
					textError={errors ? errors.opmerkingenEindeOverheidsopdracht : ''}
					textMaxLength={2000}
					validationMessageType={validationMessageType} />
				<DatumNVTOptioneel
					{...sharedProps}
					dateLabel="Aanvraag omgevingsvergunning"
					dateName="aanvraagOmgevingsvergunning"
					dateValue={minimaleEisen.aanvraagOmgevingsvergunning}
					dateError={errors ? errors.aanvraagOmgevingsvergunning : ''}
					checkName="vanToepassingAanvragOmgevingsvergunning"
					checkValue={minimaleEisen.vanToepassingAanvragOmgevingsvergunning}
					checkError={errors ? errors.vanToepassingAanvragOmgevingsvergunning : ''}
					textName="opmerkingenAanvraagOmgevingsvergunning"
					textValue={minimaleEisen.opmerkingenAanvraagOmgevingsvergunning}
					textError={errors ? errors.opmerkingenAanvraagOmgevingsvergunning : ''}
					textMaxLength={2000}
					validationMessageType={validationMessageType} />
				<DatumNVTOptioneel
					{...sharedProps}
					dateLabel="Verkrijgen omgevingsvergunning"
					dateName="verkrijgenOmgevingsvergunning"
					dateValue={minimaleEisen.verkrijgenOmgevingsvergunning}
					dateError={errors ? errors.verkrijgenOmgevingsvergunning : ''}
					checkName="vanToepassingVerkrijgenOmgevingsvergunning"
					checkValue={minimaleEisen.vanToepassingVerkrijgenOmgevingsvergunning}
					checkError={errors ? errors.vanToepassingVerkrijgenOmgevingsvergunning : ''}
					textName="opmerkingenVerkrijgenOmgevingsvergunning"
					textValue={minimaleEisen.opmerkingenVerkrijgenOmgevingsvergunning}
					textError={errors ? errors.opmerkingenVerkrijgenOmgevingsvergunning : ''}
					textMaxLength={2000}
					validationMessageType={validationMessageType} />
				<DatumNVTOptioneel
					{...sharedProps}
					dateLabel="Start werken"
					dateName="startWerken"
					dateValue={minimaleEisen.startWerken}
					dateError={errors ? errors.startWerken : ''}
					textName="opmerkingenStartWerken"
					textValue={minimaleEisen.opmerkingenStartWerken}
					textError={errors ? errors.opmerkingenStartWerken : ''}
					checkInvisible
					textMaxLength={2000}
					validationMessageType={validationMessageType} />
				<DatumNVTOptioneel
					{...sharedProps}
					dateLabel="Voorlopige oplevering"
					dateName="voorlopigeOplevering"
					dateValue={minimaleEisen.voorlopigeOplevering}
					dateError={errors ? errors.voorlopigeOplevering : ''}
					textName="opmerkingenVoorlopigeOplevering"
					textValue={minimaleEisen.opmerkingenVoorlopigeOplevering}
					textError={errors ? errors.opmerkingenVoorlopigeOplevering : ''}
					checkInvisible
					textMaxLength={2000}
					validationMessageType={validationMessageType} />
				<DatumNVTOptioneel
					{...sharedProps}
					dateLabel="Opening"
					dateName="opening"
					dateValue={minimaleEisen.opening}
					dateError={errors ? errors.opening : ''}
					checkName="vanToepassingOpening"
					checkValue={minimaleEisen.vanToepassingOpening}
					checkError={errors ? errors.vanToepassingOpening : ''}
					textName="opmerkingenOpening"
					textValue={minimaleEisen.opmerkingenOpening}
					textError={errors ? errors.opmerkingenOpening : ''}
					checkInvisible
					textMaxLength={2000}
					validationMessageType={validationMessageType} />
				<DatumNVTOptioneel
					{...sharedProps}
					dateLabel="Definitieve oplevering"
					dateName="definitieveOplevering"
					dateValue={minimaleEisen.definitieveOplevering}
					dateError={errors ? errors.definitieveOplevering : ''}
					textName="opmerkingenDefinitieveOplevering"
					textValue={minimaleEisen.opmerkingenDefinitieveOplevering}
					textError={errors ? errors.opmerkingenDefinitieveOplevering : ''}
					checkInvisible
					textMaxLength={2000}
					validationMessageType={validationMessageType} />
			</Fieldset>
		);
	}
}

WerkenOpgeleverd.propTypes = {
	minimaleEisen: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	onChangeDateNVT: PropTypes.func.isRequired,
	otherInfrastructuren: PropTypes.array.isRequired,
	onCopyMijlpalen: PropTypes.func.isRequired,
	validationMessageType: PropTypes.string
};

export default WerkenOpgeleverd;
